 
<div class="pending-orders-page">
  <div class="pending-orders-container">
    <umkt-breadcrumb [items]="breadcrumbItems" [separator]="'>'"></umkt-breadcrumb>

    <header class="pending-orders-header">
      <h1 class="pending-orders-title">{{ 'pages.pendingOrders.title' | i18n }}</h1>
      <p class="pending-orders-subtitle">{{ 'pages.pendingOrders.subtitle' | i18n }}</p>
    </header>

    <div *ngIf="isLoading">
      <umkt-loading
        [size]="'lg'"
        [isLoading]="isLoading"
        [showText]="true"
        [text]="'pages.pendingOrders.loading' | i18n"
        mode="overlay"
      ></umkt-loading>
    </div>

    <p *ngIf="error && !isLoading" class="pending-orders-error" role="alert">
      {{ error }}
    </p>

    <ng-container *ngIf="!isLoading && !error">
      <ng-container *ngIf="currentOrders.length > 0">
        <div class="pending-orders-toolbar">
          <div class="pending-orders-sort">
            <label class="pending-orders-sort__label" for="pending-order-select">
              {{ 'pages.orders.orderLabel' | i18n }}
            </label>
            <select
              id="pending-order-select"
              class="pending-orders-sort__select"
              [(ngModel)]="selectedOrder"
              (change)="onOrderChange()"
            >
              <option *ngFor="let option of orderOptions" [value]="option.value">
                {{ option.label | i18n }}
              </option>
            </select>
          </div>
        </div>

        <umkt-pending-order-panel
          [orders]="currentOrders"
          (completeData)="onCompleteData($event)"
        ></umkt-pending-order-panel>

        <div class="pending-orders-pagination" *ngIf="totalPages > 1">
          <div class="pending-orders-pagination__info">
            {{ getPageInfoText() | i18n: getPageInfoParams() }}
          </div>
          <div class="pending-orders-pagination__nav">
            <button
              type="button"
              class="pending-orders-pagination__btn"
              [disabled]="currentPage <= 0"
              (click)="goToPreviousPage()"
              [attr.aria-label]="'pages.orders.pagination.first' | i18n"
            >
              &lt;
            </button>
            <ng-container *ngFor="let page of getVisiblePages()">
              <button
                *ngIf="page === -1"
                type="button"
                class="pending-orders-pagination__btn pending-orders-pagination__btn--ellipsis"
                disabled
              >
                ...
              </button>
              <button
                *ngIf="page !== -1"
                type="button"
                class="pending-orders-pagination__btn"
                [class.pending-orders-pagination__btn--active]="page === currentPage"
                (click)="goToPage(page)"
              >
                {{ page + 1 }}
              </button>
            </ng-container>
            <button
              type="button"
              class="pending-orders-pagination__btn"
              [disabled]="currentPage >= totalPages - 1"
              (click)="goToNextPage()"
            >
              &gt;
            </button>
          </div>
        </div>
      </ng-container>

      <div class="pending-orders-empty" *ngIf="currentOrders.length === 0">
        <div class="pending-orders-empty__icon" aria-hidden="true">
          <span class="mdn-Icon-check-circulo mdn-Icon--lg"></span>
        </div>
        <h2 class="pending-orders-empty__title">
          {{ 'pages.pendingOrders.empty.title' | i18n }}
        </h2>
        <p class="pending-orders-empty__description">
          {{ 'pages.pendingOrders.empty.description' | i18n }}
        </p>
      </div>
    </ng-container>
  </div>
</div>
